import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../../shared-module/seguridad/services/auth.guard';

import { QmMatrizMantenimientoComponent } from './views/qm-matriz-mantenimiento/qm-matriz-mantenimiento.component';
import { QmMatrizUploadCsvComponent } from './views/qm-matriz-upload-csv/qm-matriz-upload-csv.component';
import { QmMatrizHistoricoComponent } from './views/qm-matriz-historico/qm-matriz-historico.component';


const routes: Routes = [
  { path: 'rdl/qm-mantenimiento', component: QmMatrizMantenimientoComponent, canActivate: [AuthGuard]},
  { path: 'rdl/qm-matriz-carga', component: QmMatrizUploadCsvComponent, canActivate: [AuthGuard]},
  { path: 'rdl/qm-matriz-historia', component: QmMatrizHistoricoComponent, canActivate: [AuthGuard]},

];


@NgModule({
  declarations: [],
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [RouterModule]
})
export class PLMRoutingModule { }
